var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{attrs:{"data-placeholder":_vm.placeholder,"multiple":_vm.multiple}},_vm._l((_vm.customOptions),function(option,index){return _c('option',{key:index,domProps:{"value":option.id}},[_vm._v("\n    "+_vm._s(option.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd46eb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chosen/Chosen.vue
// module id = null
// module chunks = 